import './index.css'

const About = () => (
  <div className="main-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/about-blog-img.png"
      alt="about"
      width="200px"
      className="img"
    />
    <h1 className="main-text">About</h1>
    <p className="sub-text">I love to create! I am a frontend web developer</p>
  </div>
)

export default About
